/** Base site fields from CMS BaseSiteInfo (start page / page content). Values are unwrapped from EPI `.value`. */
export interface BaseSiteData {
  brand_Name_HE?: string;
  brand_Name_EN?: string;
  whatsAppSale?: string;
  whatsAppSelfCare?: string;
  whatsAppTechnicalService?: string;
  financeCallNumber1?: string;
  financeCallNumber2?: string;
  businessCallNumber?: string;
  numberCallCenterAbroad?: string;
  energyCallCenter?: string;
  idfCellcomCenter?: string;
  idfCellcomCenterFullNumber?: string;
  technicalSupportPhone?: string;
  mainLogo?: string;
  siteLogo?: string;
  newLoginUrl ?: string;
  orgEmplyeeFamilyUrl ?: string;
  lobbyUrl ?: string;
}

export const BASE_SITE_DATA_KEYS: (keyof BaseSiteData)[] = [
  'brand_Name_HE',
  'brand_Name_EN',
  'whatsAppSale',
  'whatsAppSelfCare',
  'whatsAppTechnicalService',
  'financeCallNumber1',
  'financeCallNumber2',
  'businessCallNumber',
  'numberCallCenterAbroad',
  'energyCallCenter',
  'idfCellcomCenter',
  'idfCellcomCenterFullNumber',
  'technicalSupportPhone',
  'mainLogo',
  'siteLogo',
  'newLoginUrl',
  'orgEmplyeeFamilyUrl',
  'lobbyUrl'
];


const BASE_SITE_SOURCE_KEYS: Partial<Record<keyof BaseSiteData, string>> = {
  lobbyUrl: 'personalNavigationLink',
};

function unwrapPropertyValue(prop: unknown): unknown {
  if (prop == null) return undefined;
  if (typeof prop === 'object' && 'value' in (prop as object)) {
    return (prop as {value: unknown}).value;
  }
  return prop;
}

function readStringOrPageUrl(value: unknown): unknown {
  if (value && typeof value === 'object' && 'url' in value) {
    const url = (value as {url?: unknown}).url;
    return typeof url === 'string' ? url : undefined;
  }
  return value;
}

export function extractBaseSiteData(content: Record<string, unknown> | null | undefined): Partial<BaseSiteData> {
  if (!content || typeof content !== 'object') return {};

  const result: Partial<BaseSiteData> = {};
  for (const key of BASE_SITE_DATA_KEYS) {
    const sourceKey = BASE_SITE_SOURCE_KEYS[key];
    const contentKey = sourceKey ?? key;
    if (!(contentKey in content)) continue;
    const unwrapped = unwrapPropertyValue(content[contentKey]);
    const value = sourceKey ? readStringOrPageUrl(unwrapped) : unwrapped;
    if (value !== undefined && value !== null && value !== '') {
      result[key] = value as BaseSiteData[typeof key];
    }
  }
  return result;
}

export function mergeBaseSiteData(
  target: Record<string, unknown>,
  content: Record<string, unknown> | null | undefined,
): Record<string, unknown> {
  Object.assign(target, extractBaseSiteData(content));
  return target;
}
